import { isNullOrUndefined, isUndefinedOrEmpty } from '@afterpay/utils'

import { DEFAULT_INPUT_SIZE } from './constants'

const formatWithLocale = (value: string, locale: string): string => {
  if (isUndefinedOrEmpty(value)) {
    return ''
  }

  const hasTrailingDecimal = value.endsWith('.')

  const decimalIndex = value.indexOf('.')
  const hasDecimal = decimalIndex !== -1
  const digitsAfterDecimal = hasDecimal ? value.length - decimalIndex - 1 : 0

  const hasTrailingZeroInDecimal = hasDecimal && value.endsWith('0') && digitsAfterDecimal > 0 && digitsAfterDecimal <= 2
  if (hasDecimal && digitsAfterDecimal <= 2 && (digitsAfterDecimal <= 1 || hasTrailingZeroInDecimal)) {
    const [integerPart, decimalPart] = value.split('.')
    const integerValue = parseInt(integerPart, 10)

    if (isNaN(integerValue)) {
      return value
    }

    const formattedInteger = new Intl.NumberFormat(locale, {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(integerValue)

    return `${formattedInteger}.${decimalPart}`
  }

  const numericValue = parseFloat(value)
  if (isNaN(numericValue)) {
    return value
  }

  const formatted = new Intl.NumberFormat(locale, {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(numericValue)

  return hasTrailingDecimal ? formatted + '.' : formatted
}

export const getDisplayValue = (rawValue: string, locale?: string): string => {
  if (isNullOrUndefined(locale) || isUndefinedOrEmpty(locale)) {
    return rawValue
  }

  return formatWithLocale(rawValue, locale)
}

export const getInputSize = (value: string, placeholder?: string, isMobileBrowser?: boolean): number => {
  if (isMobileBrowser) {
    const nonDigitCount = value.replace(/\d/g, '').length
    const sizeAdjustment = nonDigitCount === 0 ? 1 : nonDigitCount >= 2 ? -1 : 0
    return value.length + sizeAdjustment
  }

  if (value.length > 0) {
    const hasNonDigits = /\D/.test(value)
    const sizeAdjustment = hasNonDigits ? 1 : 0
    return value.length - sizeAdjustment
  }

  if (!isNullOrUndefined(placeholder) && placeholder.length > 0) {
    return placeholder.length
  }

  return DEFAULT_INPUT_SIZE
}
